export default "__VITE_ASSET__DkQdswyW__"